import Vue from 'vue';
import KEYS from '../../../values/keys';

export default Vue.component('ed-lesson-nav-link', {
  props: ['active', 'href', 'disabled', 'type'],
  data: () => {
    return {
      isLink: true
    }
  },
  created() {
    this.isLink = this.type == KEYS.LINK_TYPE.ROUTE ? false : true;
  }
});
